import React, { useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import { profileOperations } from '../../state/ducks/profile';
import { cartOperations } from '../../state/ducks/cart';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  header: {
    borderBottom: `1px solid ${theme.palette.gray}`,
    marginBottom: '50px',
  },

  button: {
    marginTop: '25px',
  },
  text: {
    textAlign: 'left',
    color: theme.palette.gray,
  },
  card: {
    padding: '40px',
  },

}));

function CheckoutSuccess(props) {
  const classes = useStyles();
  const profile = useSelector((state) => state.profile.getProfile.profile);

  useEffect(() => {
    // clearCart();

  }, []);

  return (
    <div className={classes.root}>

      <Grid className={classes.header} container>

        <Typography>Check Out</Typography>

      </Grid>

      <Card className={classes.card} variant="outlined">

        <Typography className={classes.text} variant="h5" style={{ marginBottom: '10px' }}>Thank You</Typography>
        <Typography className={classes.text} variant="body1">Please check your email for your order confirmation</Typography>

      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  items: state.cart.cart.items,
  profile: state.profile.getProfile.profile,
});

const mapDispatchToProps = {
  // getSupplierProducts: productOperations.getSupplierProducts,
  addPayment: profileOperations.addPayment,
  updateShop: profileOperations.updateShop,
  getProfile: profileOperations.getProfile,
  clearCart: cartOperations.clearCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccess);
